import { render, staticRenderFns } from "./OrderInfoAdmin.vue?vue&type=template&id=4e1a3e26&"
import script from "./OrderInfoAdmin.vue?vue&type=script&lang=js&"
export * from "./OrderInfoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports